'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./switch.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// TODO create HOC for Checkbox and Switch component
function Switch(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      label = _ref.label,
      size = _ref.size,
      style = _ref.style,
      props = _objectWithoutProperties(_ref, ['className', 'disabled', 'label', 'size', 'style']);

  var classes = (0, _classnames2.default)('switch', className, disabled && 'switch--disabled', 'switch--' + size);

  return _react2.default.createElement(
    'label',
    { className: classes, style: style },
    _react2.default.createElement('input', _extends({
      type: 'checkbox',
      className: 'switch__input',
      disabled: disabled
    }, props)),
    _react2.default.createElement('span', { className: 'switch__slider' }),
    label && _react2.default.createElement(
      'span',
      { className: 'switch__label' },
      label
    )
  );
}

Switch.propTypes = {
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  size: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  style: _propTypes2.default.object
};

Switch.defaultProps = {
  size: 'medium',
  style: {}
};

exports.default = Switch;